import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft, RotateCcw } from "lucide-react";
import { Button } from "../components/ui/button";

export default function ConsultationCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F5F1EB] to-white flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
        <div className="w-20 h-20 bg-[#E2725B]/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-[#E2725B]" />
        </div>
        
        <h1 className="text-2xl font-bold text-[#2D2D2D] mb-3">
          Paiement annulé
        </h1>
        
        <p className="text-[#5C5C5C] mb-8">
          Votre réservation n'a pas été finalisée. Vous pouvez réessayer à tout moment.
        </p>

        <div className="space-y-3">
          <Button
            onClick={() => navigate("/consultation/checkout")}
            className="w-full bg-gradient-to-r from-[#E2725B] to-[#D4A574] hover:opacity-90 text-white py-5 rounded-full"
            data-testid="retry-consultation-btn"
          >
            <RotateCcw className="w-5 h-5 mr-2" />
            Réessayer
          </Button>
          
          <Button
            onClick={() => navigate("/")}
            variant="outline"
            className="w-full border-[#E8E4DE] text-[#5C5C5C] hover:bg-[#F5F1EB] py-5 rounded-full"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Button>
        </div>
      </div>
    </div>
  );
}
